import { XML_ScaleAndShiftY } from "./XML_ScaleAndShiftY";
import { XML_ScaleAndShiftX } from "./XML_ScaleAndShiftX";
import { XML_AddPair } from "./XML_AddPair";
import { XML_AddSingle } from "./XML_AddSingle";
import { XML_Scale } from "./XML_Scale";
import { enumPicMask } from "../constants";
import { getBase64Image } from "./getBase64Image";

export function XML_DrawImagePDF(
  x,
  y,
  width,
  height,
  clipRect,
  pictureMask,
  cell,
  drawElement,
  layer,
  linecolor,
  isIcon
) {
  var cellDesc = cell.GetCellDesc();
  var pDesc = cellDesc.GetPicSourceInfo();

  if (clipRect) drawElement.AddClipRect(clipRect, layer);

  var s = drawElement.GetStream();
  drawElement.OutputElementHead(s, "im");

  x = XML_ScaleAndShiftX(x, drawElement, layer);
  y = XML_ScaleAndShiftY(y, drawElement, layer);
  width = XML_Scale(width, drawElement, layer);
  height = XML_Scale(height, drawElement, layer);
  y = drawElement.ConvertY(y) - height;

  XML_AddPair(x, y, "pos", drawElement);
  XML_AddPair(width, height, "src", drawElement);
  if (isIcon) {
    XML_AddSingle(isIcon, "isIcon", drawElement);
  }

  XML_AddSingle(pDesc.fDirectory, "directory", drawElement);
  XML_AddSingle(pDesc.fFileName, "picfile", drawElement);
  XML_AddSingle(layer, "master", drawElement);
  if (pictureMask === enumPicMask.circle) {
    XML_AddPair("cir", linecolor, "mask", drawElement);
  } else if (pictureMask === enumPicMask.grayscale) {
    XML_AddSingle("gray", "mask", drawElement);
  }
  drawElement.OutputElementTail(s, "im");
}
